import { Fragment } from 'react'

import Disclaimer from 'reactSite/MyOrders/components/Disclaimer'

const ORDER_STATUS = {
  WAITING_PAYMENT: 'Pedido recebido',
  WAITING_SEPARATION: 'Pedido em separação'
}

export const shouldDisplayPickupMessage = status =>
  [ORDER_STATUS.WAITING_PAYMENT, ORDER_STATUS.WAITING_SEPARATION].includes(status)

const pickUpMessage = {
  [ORDER_STATUS.WAITING_PAYMENT]: (
    <Fragment>
      <strong>Atenção!</strong> Você poderá ir <strong>à loja</strong> para
      retirar o seu pedido{' '}
      <strong>24 horas após a confirmação do seu pagamento.</strong> Mas não se
      preocupe, estamos cuidando de tudo e encaminharemos um novo e-mail quando
      seu pagamento for aprovado.
    </Fragment>
  ),
  [ORDER_STATUS.WAITING_SEPARATION]: (
    <Fragment>
      <strong>Atenção!</strong> Estamos realizando a <strong>separação</strong>{' '}
      do seu produto e <strong>em 24 horas</strong> você poderá ir à loja para
      retirá-lo. Você ainda receberá um{' '}
      <strong>e-mail de confirmação quando estiver tudo pronto.</strong> Aguarde
      só mais um pouquinho.
    </Fragment>
  )
}

export const getPickUpStatusMessage = status =>
  pickUpMessage[status] ?? null

export const isPickup = (orderType) => orderType === 'Clique e retire'

export const getDriveThruMessage = (hasRegionDriveThru) => (
  hasRegionDriveThru && <strong>Devido ao cenário atual, para a segurança de todas as pessoas, as retiradas funcionarão apenas através do Drive-Thru em nossas lojas.</strong>
)

const getCurrentStep = steps => steps.filter((step) => step.current)[0]?.description

export const BuilderDisclaimer = ({ steps, type, hasRegionDriveThru }) => {
  const currentStep = steps && getCurrentStep(steps)

  const disclaimers = [
    (isPickup(type) && getPickUpStatusMessage(currentStep)) ?? null,
    (isPickup(type) && getDriveThruMessage(hasRegionDriveThru)) ?? null
  ]

  const hasDisclaimers = disclaimers.filter(Boolean).length

  if (!hasDisclaimers) {
    return null
  }

  return (
    <Disclaimer type="warning" disclaimers={disclaimers} />
  )
}
